import { apiClient } from "@/lib/api";

export const createAgency = (payload) => apiClient.post("/agency", payload);
export const getMyAgency = () =>
  apiClient.get("/agency/me", { validateStatus: (s) => (s >= 200 && s < 300) || s === 404 });
export const getAgencyOverview = () => apiClient.get("/agency/overview");
export const listClients = () => apiClient.get("/agency/clients");
export const addClient = (payload) => apiClient.post("/agency/clients", payload);
export const deleteClient = (id) => apiClient.delete(`/agency/clients/${id}`);
export const agencyTalent = (role) => apiClient.get("/agency/talent", { params: role ? { role } : {} });
export const agencyOpenJobs = () => apiClient.get("/agency/jobs");
export const submitToJob = (job_id, payload) => apiClient.post(`/agency/jobs/${job_id}/submit`, payload);
export const listSubmissions = (params = {}) => apiClient.get("/agency/submissions", { params });
export const submitCandidate = (payload) => apiClient.post("/agency/submissions", payload);
export const updateSubmission = (id, status) => apiClient.patch(`/agency/submissions/${id}`, { status });

// Billing
export const getAgencyBilling = () => apiClient.get("/agency/billing");
export const agencyChangePlan = (plan) => apiClient.post("/agency/billing/change-plan", { plan });
export const agencyBuyCredits = (credits) => apiClient.post("/agency/billing/buy-credits", { credits });

// Public client-facing dossier (no auth)
export const getSubmissionDossier = (token) => apiClient.get(`/public/submission/${token}`);
export const respondSubmission = (token, action) => apiClient.post(`/public/submission/${token}/respond`, { action });
